// extracted by mini-css-extract-plugin
module.exports = {"add-shape-modal":"add-shape-modal___3nI60"};